import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useUIStore } from '@/contexts/uiStore';
import { useIsFreeUser } from '@/api/hooks/useSubscription';
import {
  getRecommendedPlan,
  clearRecommendedPlan,
  shouldShowPlanModal,
  clearShowPlanModal
} from '@/lib/recommendedPlan';
import Sidebar from './Sidebar';
import PostAuthPlanModal from './PostAuthPlanModal';

export default function DashboardLayout() {
  const { sidebarCollapsed } = useUIStore();
  const { isFree, isLoading } = useIsFreeUser();

  const [showPlanModal, setShowPlanModal] = useState(false);
  const [recommendedPlan, setRecommendedPlanState] = useState<string | undefined>();

  // Detectar se deve mostrar o modal de planos (via sessionStorage flag)
  useEffect(() => {
    if (isLoading) return;

    const shouldShow = shouldShowPlanModal();
    if (shouldShow) {
      // Limpar o flag imediatamente para não mostrar novamente em navegações futuras
      clearShowPlanModal();

      if (isFree) {
        // Usuário é free, mostrar modal
        const plan = getRecommendedPlan() || undefined;
        setRecommendedPlanState(plan);
        setShowPlanModal(true);
      } else {
        // Usuário já tem plano pago, limpar recommended plan
        clearRecommendedPlan();
      }
    }
  }, [isFree, isLoading]);

  const handleContinueFree = () => {
    clearRecommendedPlan();
    setShowPlanModal(false);
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Sidebar />
      <main className={`${sidebarCollapsed ? 'lg:pl-20' : 'lg:pl-64'} min-h-screen transition-all duration-300`}>
        <Outlet />
      </main>

      <PostAuthPlanModal
        isOpen={showPlanModal}
        onContinueFree={handleContinueFree}
        recommendedPlan={recommendedPlan}
      />
    </div>
  );
}
